import React from 'react'
import { Popup, Button, Icon, Dimmer, Image } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import { Slider, Rail, Handles, Tracks } from 'react-compound-slider'
import { Handle, Track, TooltipRail } from './ProgressComponent'
import diamond from "../../../../../images/grafix-icon/diamond.svg";
import completeActivity from "../../../../../images/grafix-icon/completeActivity.svg";
import UserList from './UserList';
import CompletedActivityModal from './../modals/CompleteActivity';
import IssueResolvedModal from '../../Drive/modals/IssueResolvedModal'
import DateFormater from './DateFormater'
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import contentIcon from "../../../../../images/svg/noti-content.svg";
import { debounce } from 'lodash'
import { toastr } from "react-redux-toastr";

var moment = require('moment');


const sliderStyle = {  // Give the slider some width
    position: 'relative',
    width: '100%',
    height: 7,
    border: 'none',
}

const progressRange = [0, 100]

let timer = 0;
let delay = 200;
let prevent = false;

class ActivityCardNew extends React.PureComponent {
    constructor(props) {

        let defaultValues = [props.activityData.progress]
        super(props);
        this.state = {
            openCompletedModal: false,
            values: defaultValues.slice(),
            update: defaultValues.slice(),
            selectedAct: false,
            startClick: false,
            IssueResolvedModalFlag: false,
            btnComplete: false,
            isModalopen: false,
           

        }
        this.clickActivity = this.clickActivity.bind(this);
    }

    onProgressChange = (values, activityData) => {
        const hasChecklist = !(activityData.initiativeId && activityData.initiativeId.includeChecklist) || 
                        (activityData.originalId && activityData.originalId.metaDataSchema && 
                        Object.keys(activityData.originalId.metaDataSchema).length === 0);

        if (!hasChecklist) {
        
            this.setState({ isModalopen: true });
            let message = <div className="confirmMessage">
                    <h3>Complete Activity</h3>
                    <label>{activityData.name}</label>
                    <p>Please complete the checklist before updating progress.</p>
                    </div>

                    {this.state.isModalopen &&  toastr.confirm(message, {
                        disableCancel: true,
                
                    onOk: () => {
                        this.setState({ isModalopen: false });
                        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                        this.clickActivity(activityData,this.props.activeTab,this.props.type);
                    }
                }); 
            }
            return;
        }

        let activity = Object.assign({}, activityData);
        this.setState({ existingProgress: activity.progress })
        activity.string = ''
        activity.completeActivitystring = '';
        activity.progress = values[0];

        if (this.props.activeTab === "myactivities") {
            dispatch.initiatives.updateMemberActivities(activity);
        }
        else {
            dispatch.initiatives.updateInitiativeActivities(activity)
        }

        if (values[0] === 100) {
            this.completedClick(true)

        }
    }

    handleClick(activityData, page, type) {

        let thisClick = this;
        timer = setTimeout(function () {
            if (!prevent) {
                thisClick.clickActivity(activityData, page, type);
            }
            prevent = false;
        }, delay);
    }

    handleDoubleClick(activityData, page, type) {
        clearTimeout(timer);
        prevent = true;
        this.doDoubleClickAction(activityData, page, type);
    }

    doDoubleClickAction(activityData, page, type) {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        this.clickActivity(activityData, page, type);
        dispatch.initiatives.splitAt("60%");
    }

    async clickActivity(activityData, page, type) {
        // We need to clear resource pane then again reactivate for refresh the data
        dispatch.initiatives.showResourecePane(null);
        let activityId = activityData._id ? activityData._id : activityData.id
        this.setState({ selectedAct: true })

        if (page === "Teams" && (type === "phase" || type === "stage")) {
            await dispatch.initiatives.getSelectedCommunityAsync(activityId);
            dispatch.initiatives.showResourecePane("Communities");
            await dispatch.initiatives.setSelectedActivityData({});
        } else {
            await dispatch.initiatives.getSelectedActivityDetails(activityId);
            dispatch.initiatives.showResourecePane("ActiveProgress");
            await dispatch.initiatives.setSelectedCommunityData({});
        }
        dispatch.initiatives.splitAt("60%");
        dispatch.initiatives.setIdToCenterPosition(activityId)

        if (this.state.startClick) {
            this.setState({ startClick: false })
            return;
        } else {
            this.setState({ startClick: false })
            let payload = {}
            payload.organizationId = this.props.selectedOrganisation.id;
            if (this.props.activeTab === "myactivities") {
                payload.teamId = this.props.selectedActivityData &&
                    this.props.selectedActivityData.initiativeId &&
                    this.props.selectedActivityData.initiativeId.teamId ?
                    this.props.selectedActivityData.initiativeId.teamId._id ?
                        this.props.selectedActivityData.initiativeId.teamId._id : this.props.selectedActivityData.initiativeId.teamId : payload.organizationId;

                payload.createdBy = this.props.selectedActivityData && this.props.selectedActivityData.initiativeId && this.props.selectedActivityData.initiativeId.createdBy;
                payload.initiativeId = this.props.selectedActivityData ? this.props.selectedActivityData.initiativeId ? this.props.selectedActivityData.initiativeId._id : '' : '';
            }
            else {
                payload.teamId = this.props.selectedDataById && this.props.selectedDataById.teamId && this.props.selectedDataById.teamId._id ? this.props.selectedDataById.teamId._id : this.props.selectedDataById.teamId;
                payload.createdBy = this.props.selectedDataById.createdBy;
                payload.initiativeId = this.props.selectedDataById._id;
            }
            if (payload.teamId)
                dispatch.initiatives.getTeamDetailsOfActivity(payload)
        }

    }



    reOpenClick = async (e, activityData) => {
        if (e) {
            e.stopPropagation()
        }
        this.setState({ btnReopen: true },async()=>{
            let activityId = activityData._id ? activityData._id : activityData.id
            let sAD = Object.assign({}, activityData);
            sAD._id = activityId
            //await dispatch.initiatives.getSelectedActivityDetails(activity._id);
            delete sAD.completeActivitystring;
            sAD.runStatus = 0
            sAD.progress = 0
            sAD.string = "reopenActivity";
            if(sAD.metaData && sAD.metaData.formElement){
                sAD.metaData.formElement = {};
            }  
            if (this.props.activeTab === "myactivities") {
               await dispatch.initiatives.updateMemberActivities(sAD);
            }
            else {
               await dispatch.initiatives.updateInitiativeActivities(sAD)
            }
            this.btnLoader()
        })
    }

    btnLoader = debounce(async () => {
        this.setState({
            btnReopen: false,
            btnStart: false,
            btnComplete: false
        })
    }, 1000)

    markComplete = (activityData, e) => {
        this.setState({ btnComplete: true })
        if (e) {
            e.stopPropagation()
        }
        let activityId = activityData._id ? activityData._id : activityData.id
        let sAD = Object.assign({}, activityData)
        sAD._id = activityId
        sAD.oldRunStatus = activityData.runStatus;
        sAD.runStatus = 2
        sAD.onHoldFlag = false;
        sAD.issueFlag = false;
        sAD.progress = 100;
        sAD.completeActivitystring = "MarkAsComplete";
        sAD.string = "";
        sAD.actualEndDate = moment();
        if (this.props.activeTab === "myactivities") {
            dispatch.initiatives.updateMemberActivities(sAD);
        }
        else {
            dispatch.initiatives.updateInitiativeActivities(sAD);
            // :Fetching the initiatives count 
            let payload = {
                organizationId: this.props.selectedOrganisation.id
            }
            dispatch.initiatives.getinitiativesCount(payload);
        }
        this.btnLoader()
    }

    completedClick = (openCompletedModal) => {
        this.setState({ openCompletedModal: openCompletedModal })
        setTimeout(() => {
            this.setState({ values: [this.props.activityData.progress], update: [this.props.activityData.progress] })
        }, 300);
    }

    markComplete = (activityData, e) => {
        if (e) {
            e.stopPropagation()
        }
        let activityId = activityData._id ? activityData._id : activityData.id
        let sAD = Object.assign({}, this.props.selectedActivityData)
        sAD._id = activityId
        sAD.oldRunStatus = this.props.selectedActivityData.runStatus;
        sAD.runStatus = 2
        sAD.onHoldFlag = false;
        sAD.issueFlag = false;
        sAD.progress = 100;
        sAD.completeActivitystring = "MarkAsComplete";
        sAD.string = "";
        sAD.actualEndDate = moment();
        if (this.props.activeTab === "myactivities") {
            dispatch.initiatives.updateMemberActivities(sAD);
        }
        else {
            dispatch.initiatives.updateInitiativeActivities(sAD);
            // :Fetching the initiatives count 
            let payload = {
                organizationId: this.props.selectedOrganisation.id
            }
            dispatch.initiatives.getinitiativesCount(payload);
        }
    }


    async startClick(e, activityData) {
        // this.setState({ btnStart: true })
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        let activityId = activityData._id ? activityData._id : activityData.id
        this.setState({ startClick: true, selectedId: activityId, btnStart: true }, async ()=>{
            let activity = Object.assign({}, activityData)
            activity.runStatus = 1
            activity.actualStartDate = moment()
            activity.string = "startActivity";
            activity.completeActivitystring = "";
    
            if (this.props.activeTab === "myactivities") {
                await dispatch.initiatives.updateMemberActivities(activity);
            }
            else {
    
                await dispatch.initiatives.updateInitiativeActivities(activity)
            }
            this.btnLoader()
        });
    }

    popupHover() {
        let activityId = this.props.activityData._id ? this.props.activityData._id : this.props.activityData.id
        dispatch.initiatives.setRACIUsers([])
        dispatch.initiatives.getActivityRACIUsersAsync(activityId)
    }

    resolvedClick = (e, IssueResolvedModalFlag) => {
        this.setState({ IssueResolvedModalFlag: IssueResolvedModalFlag })
        e.stopPropagation()
    }
    closedIssueResolvedModal = (IssueResolvedModalFlag) => {
        this.setState({ IssueResolvedModalFlag: IssueResolvedModalFlag })
    }
    hoverComponent = (trigger) => {
        return (<Popup
            onOpen={() => this.popupHover()}
            trigger={trigger}
            flowing
            hoverable
            on='hover'
            basic
            className="popupStyledWhite"
        >
            <UserList activityData={this.props.activityData} activityRACIUsers={this.props.activityRACIUsers} />
        </Popup>)
    }
    getMapping(id) {
        let initiativeCommunities = this.props.selectedDataById && this.props.selectedDataById.communities ? this.props.selectedDataById.communities : this.props.activityData && this.props.activityData.initiativeId.communities ? this.props.activityData.initiativeId.communities : [];
        if (initiativeCommunities)
            for (let i = 0; i < initiativeCommunities.length; i++) {
                let community = initiativeCommunities[i];
                if (id === community._id) {
                    return community.name;
                }
                if (community.communities) {
                    for (let j = 0; j < community.communities.length; j++) {
                        let subCommunity = community.communities[j];
                        if (id === subCommunity._id) {
                            return community.name + " > " + subCommunity.name;
                        }
                    }
                }
            }
    }



    render() {
        const {
            type,
            selectedActivityData,
            selectedPracticeFlowCommunity,
            activeTab,
            accountable,
            associatedTeamName,
            loadingUpdateInitiativeActivities,
            loadingUpdateMemberActivities,
            selectedDataById
        } = this.props;

        const { activityData } = this.props;
        let activityId = activityData._id ? activityData._id : activityData.id
        let todaysDateGetTime = moment().unix();
        let startDateGetTime = "";
        let daysDifference = "";
        let initiativeCreatedBy = "";
        let checkUser = ""


        //let communityId = this.props.activityData && this.props.activityData.raci.a.communityId && this.props.activityData.raci.a.communityId._id ? this.props.activityData.raci.a.communityId._id : this.props.activityData.raci.a.communityId
        //let initiativeCommunities = this.props.selectedDataById && this.props.selectedDataById.communities && this.props.selectedDataById.communities.length ? this.props.selectedDataById.communities : this.props.activityData.initiativeId;
        let raci = activityData && activityData.raci && activityData.raci;

        if (activeTab === "myactivities") {

            startDateGetTime = moment(this.props.activityData.initiativeId.startDate).unix();
            initiativeCreatedBy = this.props.activityData.initiativeId.createdBy;
            const findUserInR = raci && raci.r.findIndex(x => x.accountUserId._id === this.props.user._id);
            let accountableUserId = raci && raci.a.accountUserId && raci.a.accountUserId._id ? raci && raci.a.accountUserId._id : raci.a && raci.a.accountUserId
            checkUser = findUserInR >= 0 || accountableUserId === this.props.user._id || initiativeCreatedBy === this.props.user._id
        } else if (this.props.selectedDataById && (activeTab === "Progress" || activeTab === "Teams" || activeTab === "Sequence")) {

            startDateGetTime = moment(this.props.selectedDataById.startDate).unix();
            initiativeCreatedBy = this.props.selectedDataById.createdBy;
            const findUserInR = raci && raci.r.findIndex(x => x.accountUserId && x.accountUserId._id ? x.accountUserId._id === this.props.user._id : x.accountUserId === this.props.user._id);
            let accountableUserId = raci && raci.a.accountUserId && activityData.raci.a.accountUserId._id ? raci && raci.a.accountUserId._id : raci && raci.a.accountUserId
            checkUser = findUserInR >= 0 || accountableUserId === this.props.user._id || initiativeCreatedBy === this.props.user._id
        }


        if (todaysDateGetTime > startDateGetTime) {
            daysDifference = true;
        } else {
            daysDifference = false
        }

        const activityProgress = this.props.activityData.progress;

        let showStartButton = activityData.runStatus === 0 && !activityData.onHoldFlag && checkUser && daysDifference;
        let showCompleteButton = (activityData.runStatus === 0 || activityData.runStatus === 1) && !activityData.onHoldFlag && !activityData.issueFlag && checkUser && daysDifference;
        let showReopenButton = activityData.runStatus === 2 && checkUser;
        let checkDependency = this.props.selectedActivityData && this.props.selectedActivityData.dependencies && this.props.selectedActivityData.dependencies.length > 0 && this.props.selectedActivityData.dependencies.indexOf(activityId) != -1;
        let selectedActivityId = selectedActivityData && selectedActivityData._id ? selectedActivityData._id : null;
        let selectedCommunityId = selectedPracticeFlowCommunity && selectedPracticeFlowCommunity._id ? selectedPracticeFlowCommunity._id : null;

        let setHeight = activeTab === "Teams" && (type === "phase" || type === "stage") ? "90px" :
            activeTab === "Sequence" && (type === "phase" || type === "stage") ? "90px" :
                "104px";

        const styles = {
            card: {
                borderLeft: "5px solid " + `${activityData && activityData.tagColor ? activityData.tagColor : "#ccc"} `,
                position: "relative",
                height: setHeight
            }
        }


        let isInitiativeEditingMode = activityData && activityData.initiativeId && (activityData.initiativeId.status === 3 || activityData.initiativeId.status === 4 || activityData.initiativeId.status === 5) ? true : false
        let isCanceledOrClosed = selectedDataById && (selectedDataById.status === 3 || selectedDataById.status === 5)
        let isActivityCanceled = activityData && activityData.runStatus === 3
        let inActiveCard = isInitiativeEditingMode || isCanceledOrClosed || isActivityCanceled
        return (
            <React.Fragment>
                { inActiveCard ? <div className="inEditModeOverlay" ></div> : null}
                <div
                    className={`
                activityCard cursor-pointer   
                ${!inActiveCard && activityData.runStatus === 2 ? "complete-activity-color" : ""} 
                ${!inActiveCard && type === 'activity' && activityData.runStatus === -1 ? "waiting-activity" : ""} 
                ${!inActiveCard && activityData.isMilestone ? "milestone-color" : ""} 
                ${!inActiveCard && checkDependency ? "dependency-bg-color" : ""} 
                ${selectedActivityId === activityId || selectedCommunityId === activityId ? "activeActivity" : ""} 
            `}

                    style={styles.card}
                    onClick={() => selectedActivityId === activityId || selectedCommunityId === activityId ? null : this.handleClick(activityData, activeTab, type)}
                    onDoubleClick={() => this.handleDoubleClick(activityData, activeTab, type)}
                    id={activityId + "_" + selectedActivityId}
                >
                    {/* <Dimmer active={selectedActivityId === activityId || selectedCommunityId === activityId ? this.props.loadingUpdateInitiativeActivities : false} /> */}

                    {activeTab !== "myactivities" ?
                        <div className="activity-community-border" ></div> : null
                    }
                    <div className="activity-head" >
                        <div className="activity-name">
                            <EllipsisTooltip
                                name={activityData.name}
                                position="top left"
                                line={2}
                            />
                        </div>
                    </div>

                    <div className="activity-footer" >
                        {type === 'activity' ?
                            <div className="activity-avatar">
                                <ImageAvater className="f_12 w_24 h_24 pad_2" user={this.props.activityData ? this.props.activityData : null} hoverComponent={this.hoverComponent} />
                            </div> : null}



                        {activeTab === "Teams" && accountable ?
                            <span><ImageAvater className="f_12 w_24 h_24 pad_2" user={accountable} />
                                {this.props.selectedDataById.status !== 3 ?
                                    <Button
                                        size='mini'
                                        className="button-info"
                                        onClick={!inActiveCard ? this.props.assignModal : null} >Change</Button>
                                    :
                                    null}
                            </span>
                            :
                            null}

                        {type === 'activity' ?
                            <div className="activity-status">

                                {daysDifference === null &&
                                    activityData.runStatus === 0 &&
                                    !activityData.issueFlag &&
                                    !activityData.isDelayedToEnd ?
                                    <Popup
                                        content='Not Started'
                                        className="popupStyled"
                                        mouseEnterDelay={500}
                                        inverted
                                        trigger={<div className="activity-circle-icon">
                                            <Icon className=" clr-gray" name="clock" />
                                        </div>} />
                                    : null
                                }
                                

                                {activityData.runStatus === 1 &&
                                    (!activityData.isDelayedToStart ||
                                        activityData.isDelayedToStart) &&
                                    !activityData.isDelayedToEnd &&
                                    !activityData.onHoldFlag &&
                                    !activityData.issueFlag ?
                                    <Popup
                                        content='In Progress'
                                        className="popupStyled"
                                        mouseEnterDelay={500}
                                        inverted
                                        trigger={<div className="activity-circle-icon">
                                            <Icon className="clr-green" name="clock " />
                                        </div>} />
                                    : null
                                }

                                {activityData.runStatus !== 2 &&
                                    activityData.isDelayedToEnd &&
                                    !activityData.issueFlag ?
                                    <Popup
                                        content='Delayed'
                                        className="popupStyled"
                                        mouseEnterDelay={500}
                                        inverted
                                        trigger={<div className="activity-circle-icon">
                                            <Icon className="clr-orange" name="stopwatch" />
                                        </div>} />

                                    : null
                                }

                                {activityData.issueFlag ?
                                    <Popup
                                        content='View Issue'
                                        className="popupStyled"
                                        mouseEnterDelay={500}
                                        inverted
                                        trigger={<div className="activity-circle-icon" onClick={(e) => this.resolvedClick(e, true)}>
                                            <Icon className="clr-red f_12" name="warning sign" />
                                        </div>} />
                                    : null}

                                {activityData.runStatus === 2 ?
                                    <Popup
                                        content='Completed'
                                        className="popupStyled"
                                        mouseEnterDelay={500}
                                        inverted
                                        trigger={<div className="activity-circle-icon">
                                            <Image src={completeActivity} />
                                            {/* <Icon className=" clr-blue" name="check circle outline" /> */}
                                        </div>} />
                                    : null
                                }
                            </div> : null}

                        {type === 'activity' && activityData.onHoldFlag ?
                            <Popup
                                content='On Hold '
                                className="popupStyled"
                                mouseEnterDelay={500}
                                inverted
                                trigger={<div className="activity-circle-icon">
                                    <Icon className="clr-dark-gray" name="pause circle" />
                                </div>} />
                            : null
                        }

                        

                        {type === 'activity' && showStartButton ? <Button
                            size='mini'
                            loading={this.state.btnStart}
                            disabled={this.state.btnStart || (this.props.activityData && this.props.activityData.isSmartActivity)}
                            className="button-submit"
                            onClick={(e) => !inActiveCard ? this.startClick(e, activityData) : null} >Start</Button> : null
                        }

                        {this.props.currentOrganization && 
                        Array.isArray(this.props.currentOrganization.integrations) &&
                        this.props.type === "activity" &&
                        this.props.currentOrganization.integrations.some(integration => integration.type === "make") &&

                         (this.props.activityData.initiativeActivityActions && 
                            Array.isArray(this.props.activityData.initiativeActivityActions) &&
                            this.props.type === 'activity' &&
                            this.props.activityData.initiativeActivityActions.some(action => action.name === "make.com")) && 
                            (
                                 <Popup
                                    content='make.com'
                                    className="popupStyled"
                                    mouseEnterDelay={500}
                                    position="top right"
                                    trigger={
                                        <div className="activity-circle-icon" >
                                            <img 
                                                src={"https://res.cloudinary.com/aspenify-dev/image/upload/v1734520930/ih5xnyzus1ungzwtaohc.png"} 
                                                name="make.com" alt='make.com' 
                                                style={{ margin: "4px",borderRadius: "100%" }} 
                                            />

                                        </div>
                                    }
                                />

                            )
                        }

                                            
                        

                        {/* {type === 'activity' && showCompleteButton ? <Button
                        size='mini'
                        loading={this.state.btnComplete && (loadingUpdateInitiativeActivities || loadingUpdateMemberActivities)}
                        disabled={this.state.btnComplete && (loadingUpdateInitiativeActivities || loadingUpdateMemberActivities)}
                        className="button-info"
                        onClick={(e) => this.markComplete(activityData, e)} >Complete</Button> : null
                    } */}

                        {type === 'activity' && showReopenButton ? <Button
                            size='mini'
                            className="button-info"
                            loading={this.state.btnReopen}
                            disabled={this.state.btnReopen || (this.props.activityData && this.props.activityData.isSmartActivity)}
                            onClick={(e) => !inActiveCard ? this.reOpenClick(e, activityData) : null} >Reopen</Button> : null
                        }

                        {type === 'activity' && checkDependency ?
                            <div className="activity-milestone-dependency">
                                <Icon className="dependency-color clr-blue" name="linkify" />
                            </div> : null
                        }

                        {type === 'activity' && activityData.isMilestone ?
                            <Popup
                                content='Milestone'
                                className="popupStyled"
                                mouseEnterDelay={500}
                                position="top right"
                                inverted
                                trigger={<div className="activity-circle-icon pull-right mar_0">
                                    <img src={diamond} name="diamond" alt='Milestone' />
                                </div>} />
                            : null
                        }
                    </div>

                    <div className="activity-count-box" >
                        {activeTab === "Teams" && type === 'stage' ?
                            <span>
                                <Popup
                                    content='Team'
                                    className="popupStyled"
                                    mouseEnterDelay={500}
                                    position="top right"
                                    inverted
                                    trigger={<Icon name="group" />} />&nbsp;
                            {associatedTeamName}
                            </span> : null}

                        {type === 'activity' ?
                            <Popup
                                content='Duration'
                                className="popupStyled"
                                mouseEnterDelay={500}
                                inverted
                                trigger={<div><Icon name="calendar alternate" /> {activityData.duration}</div>} /> : null}
                        {activityData.notes && activityData.notes.length !== 0 ?
                            <Popup
                                className="popupStyled"
                                mouseEnterDelay={500}
                                inverted
                                content='Comment'
                                position="top right"
                                trigger={<div className={`${type === "phase" || type === "stage" ? "float-left text-left" : "float-right text-right"}`} ><Icon name="comment" flipped="horizontally" /> {activityData.notes && activityData.notes.length}</div>} /> : null}
                        {activityData.references && activityData.references.length !== 0 ?
                            <Popup
                                content='References'
                                position="top right"
                                className="popupStyled"
                                mouseEnterDelay={500}
                                inverted
                                trigger={<div className={`${type === "phase" || type === "stage" ? "float-left text-left" : "float-right text-right"}`} style={{ width: "40px" }}><Image style={{ height: "10px", verticalAlign: "inherit", maxWidth: "30px" }} src={contentIcon} /> <span >{activityData.references && activityData.references.length}</span></div>} /> : null}
                        {activityData.attachments && activityData.attachments.length !== 0 ?
                            <Popup
                                content='Attachment'
                                position="top right"
                                className="popupStyled"
                                mouseEnterDelay={500}
                                inverted
                                trigger={<div className={`${type === "phase" || type === "stage" ? "float-left text-left" : "float-right text-right"}`} ><Icon name="attach" /> {activityData.attachments && activityData.attachments.length}</div>} /> : null}
                    </div>

                    <div className="activity-date-slider">
                        {type === 'activity' && (activityData.runStatus === 0 ||
                            activityData.runStatus === -1) ?
                            <DateFormater date={activityData.expectedStartDate} />
                            : null
                        }
                        
                        {type === 'activity' && activityData.runStatus === 1 && activityData.onHoldFlag === false?
                            <div className="activity-slider" style={{ margin: "10px 0 0 0" }} onClick={(e) => e.stopPropagation()}>
                                <Slider
                                    className="progressRangeSlider "
                                    mode={1}
                                    step={1}
                                    domain={progressRange}
                                    rootStyle={sliderStyle}
                                    onChange={(value) => this.onProgressChange(value, activityData)}
                                    values={[activityProgress]}
                                    disabled={checkUser ? false : true}
                                >
                                    <Rail>{railProps => <TooltipRail showTooltip={checkUser} {...railProps} />}</Rail>
                                    {checkUser ? <Handles>
                                        {({ handles, activeHandleID, getHandleProps }) => (
                                            <div className="slider-handles">
                                                {handles.map(handle => (
                                                    <Handle
                                                        key={handle.id}
                                                        handle={handle}
                                                        domain={progressRange}
                                                        isActive={handle.id === activeHandleID}
                                                        getHandleProps={getHandleProps}
                                                        disabled={checkUser ? false : true}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </Handles> : null}
                                    <Tracks right={false}>
                                        {({ tracks, getTrackProps }) => (
                                            <div className="slider-tracks">
                                                {tracks.map(({ id, source, target }) => (
                                                    <Track
                                                        key={id}
                                                        source={source}
                                                        target={target}
                                                        getTrackProps={getTrackProps}
                                                        disabled={checkUser ? false : true}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </Tracks>
                                </Slider>
                            </div> : null}
                    </div>




                    <CompletedActivityModal open={this.state.openCompletedModal}
                        completedClick={this.completedClick}
                        selectedActivityData={activityData}
                        selectedOrganisation={this.props.selectedOrganisation}
                        activeTab={activeTab}
                        existingProgress={this.state.existingProgress}
                        from="activityCard" />

                    {activityData.issueFlag && activityData.issueLogComments
                        && activityData.issueLogComments.length ?
                        <IssueResolvedModal
                            IssueResolvedModalFlag={this.state.IssueResolvedModalFlag}
                            selectedActivityData={activityData}
                            IssueResolvedModal={this.closedIssueResolvedModal}
                            user={this.props.user}
                            activeTab={activeTab}
                        />
                        : null}
                </div >
            </React.Fragment>
        )
    }
}

export default ActivityCardNew;